import FileUploadCrop from './FileUploadCrop'

export default FileUploadCrop
